import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import cn from 'classnames'
import { Flex } from 'shared/ui'
import { isForwarding } from 'util/draft'
import { getValueByPath } from 'util/objects'

import ToRow from '../ToRow'
import CcRow from '../CcRow'
import BccRow from '../BccRow'
import FromRow from '../FromRow'
import SubjectRow from '../SubjectRow'

const Expanded = ({
  bccVisible,
  ccVisible,
  children, // i.e. FormSwitcherButton
  className,
  closeTo,
  draft,
  draftId,
  draftType,
  focusField,
  forwarding,
  fromVisible,
  mailboxId,
  onActionClick,
  onMailboxClick,
  onSubjectChange,
  onSubjectEnter,
  recipients,
  recipientsTo,
  recipientsCc,
  recipientsBcc,
  recipientsOpenUpward,
  subjectVisible,
  subject,
  ticketId,
  onToUpdate,
  onCcUpdate,
  onBccUpdate,
}) => {
  // if we provide a children prop, its assumed its a FormSwitcherButton, so we
  // indent all subsequent rows by 52px
  const indent = children ? '40px' : undefined
  const startInEditMode =
    ((isForwarding(draftType) || forwarding) &&
      !getValueByPath('to[0].id', recipients)) ||
    focusField === 'to'

  return (
    <Flex className={cn('grui flex-col', className)}>
      <ToRow
        bccVisible={bccVisible}
        ccVisible={ccVisible}
        closeTo={closeTo}
        fromVisible={fromVisible}
        isForwarding={isForwarding(draftType)}
        onActionClick={onActionClick}
        subjectVisible={subjectVisible}
        ticketId={ticketId}
        recipients={recipientsTo || (recipients && recipients.to)}
        recipientsOpenUpward={recipientsOpenUpward}
        startInEditMode={startInEditMode}
        key={ticketId}
        onUpdate={onToUpdate}
      >
        {children}
      </ToRow>

      {ccVisible && (
        <div style={{ marginLeft: indent }}>
          <CcRow
            recipients={recipientsCc || (recipients && recipients.cc)}
            startInEditMode={focusField === 'cc'}
            ticketId={ticketId}
            recipientsOpenUpward={recipientsOpenUpward}
            onUpdate={onCcUpdate}
          />
        </div>
      )}

      {bccVisible && (
        <div style={{ marginLeft: indent }}>
          <BccRow
            recipients={recipientsBcc || (recipients && recipients.bcc)}
            startInEditMode={focusField === 'bcc'}
            ticketId={ticketId}
            recipientsOpenUpward={recipientsOpenUpward}
            onUpdate={onBccUpdate}
          />
        </div>
      )}

      {fromVisible && (
        <div style={{ marginLeft: indent }}>
          <FromRow
            draft={draft}
            mailboxId={mailboxId}
            onMailboxClick={onMailboxClick}
          />
        </div>
      )}

      {subjectVisible && (
        <div style={{ marginLeft: indent }}>
          <SubjectRow
            draft={draft}
            draftId={draftId}
            ticketId={ticketId}
            subject={subject}
            onChange={onSubjectChange}
            onEnter={onSubjectEnter}
            startInEditMode={focusField === 'subject'}
          />
        </div>
      )}
    </Flex>
  )
}

Expanded.propTypes = {
  draft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  closeTo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  recipientsOpenUpward: PropTypes.bool,
}

Expanded.defaultProps = {
  draft: null,
  closeTo: undefined,
  recipientsOpenUpward: false,
}

export default styled(Expanded)`
  width: 100%;
`
